module.exports = __webpack_public_path__ + "static/media/addressIcon.2b44c34a.svg";